import { FC } from 'react';

export interface ProntoLogoIconProps {
  height?: number | string;
  fill?: string;
}

const ProntoLogoIcon: FC<ProntoLogoIconProps> = ({
  height,
  fill = 'currentColor',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 124.42 150.32"
    style={{
      height:
        height != null
          ? typeof height === 'number'
            ? `${height}px`
            : height
          : undefined,
      fill,
    }}
    aria-hidden
  >
    <g>
      <path d="M0,0v150.32h124.42V0H0ZM12.09,12.09h68.7v91.83l-68.7,27V12.09ZM112.31,138.23H26.42l66.46-26.07V12.09h19.43v126.14Z" />
    </g>
  </svg>
);

export default ProntoLogoIcon;
